export default __webpack_public_path__ + "static/media/closeIcon.b60e9dc5.svg";